/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const CustomBullseye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Custom Bullseye"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#DFD2FC"
        d="M21.839 4.181a1.7 1.7 0 0 0-.31-.238 1.7 1.7 0 0 0-.603-.23c-.056-.009-.108-.023-.168-.028l-.197-.018-.197-.019-.018-.21-.015-.183a2 2 0 0 0-.042-.234 1.7 1.7 0 0 0-.243-.575 1.6 1.6 0 0 0-.215-.266c-.674-.674-1.983-.374-2.521.169-.538.537-.726 1.23-.646 2.399l.014.205.033.332c.056.459.14.74.248 1.076q.02.065.047.135.056.176.126.38c.136.041.258.083.375.12.037.015.07.024.107.038.337.112.618.197 1.063.257.168.024.36.042.59.057l.206.009c1.034.042 1.69-.154 2.195-.66.538-.537.84-1.843.17-2.516"
        className="Fill-Main"
      />
      <path
        fill="#0E0E0E"
        d="M9.51 12.141a2.357 2.357 0 0 0 2.355 2.354 2.357 2.357 0 0 0 2.355-2.354c0-.132-.018-.26-.04-.386l.742-.747c.132.355.205.733.205 1.133a3.27 3.27 0 0 1-3.267 3.264 3.27 3.27 0 0 1-3.266-3.264 3.27 3.27 0 0 1 3.266-3.264c.397 0 .77.073 1.121.205l-.742.747a3 3 0 0 0-.379-.037 2.36 2.36 0 0 0-2.355 2.354zm5.548-5.14a6.03 6.03 0 0 0-3.198-.919 6.07 6.07 0 0 0-6.063 6.06A6.07 6.07 0 0 0 11.86 18.2a6.07 6.07 0 0 0 6.064-6.059 6.05 6.05 0 0 0-.93-3.213l-.66.664a5.1 5.1 0 0 1 .683 2.55c0 2.84-2.31 5.148-5.152 5.148a5.154 5.154 0 0 1-5.152-5.149c0-2.84 2.31-5.148 5.152-5.148.92 0 1.786.246 2.537.674l.66-.665zm4.07 1.927c.44.982.686 2.07.686 3.213 0 4.38-3.567 7.949-7.95 7.949-4.381 0-7.953-3.57-7.953-7.949s3.567-7.948 7.954-7.948c1.141 0 2.225.244 3.206.68l-.14-1.038a8.8 8.8 0 0 0-3.066-.552C6.977 3.283 3 7.257 3 12.14S6.977 21 11.865 21s8.86-3.974 8.86-8.859a8.7 8.7 0 0 0-.61-3.213zm3.192-1.715c-.765.765-1.708.915-2.505.915-.11 0-.214 0-.319-.01l-.214-.013a7 7 0 0 1-1.294-.187c-.232-.059-.433-.127-.656-.2q-.152-.047-.323-.11l-.41.41-.642.647-.133.132-1.202 1.206-.643.647-1.339 1.343-.361.385-.018.018a.4.4 0 0 1-.31.123.47.47 0 0 1-.3-.123l-.02-.014v-.004a.47.47 0 0 1-.136-.314.42.42 0 0 1 .119-.31l.38-.403 1.339-1.348.642-.646 1.33-1.334.643-.646.419-.42-.1-.3a6.3 6.3 0 0 1-.364-1.72l-.015-.205c-.068-.997-.013-2.135.893-3.041.934-.933 2.592-.92 3.544.032.351.35.588.778.693 1.256.478.11.906.342 1.257.692.952.952.97 2.609.032 3.542zm-.646-.642c.524-.524.62-1.598-.032-2.253a1.6 1.6 0 0 0-.3-.233 1.6 1.6 0 0 0-.588-.223c-.055-.009-.105-.022-.165-.027l-.19-.018-.192-.018-.018-.205-.014-.178a2 2 0 0 0-.041-.227 1.6 1.6 0 0 0-.237-.56 1.6 1.6 0 0 0-.21-.26c-.655-.655-1.73-.56-2.254-.032-.524.524-.707 1.198-.63 2.336l.015.2c.009.118.022.223.031.323.055.446.137.72.242 1.047q.02.063.045.132l.123.369c.133.04.251.082.365.118.036.014.068.023.105.037.328.109.601.19 1.034.25.164.023.35.041.574.055l.2.009c1.007.04 1.645-.15 2.137-.642"
        className="Details"
      />
    </g>
  </svg>
);

export const CustomBullseyeIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'custom-bullseye-icon'}
      icon={CustomBullseye}
      {...props}
      size={size}
    />
  );
};
